export default "__VITE_ASSET__05eb0e2c__"